import { getFanbase_api } from 'api/brandApi'
import { Fan, FetchFanbaseParams } from 'modules/Types'
import { create } from 'zustand'
import { immer } from 'zustand/middleware/immer'
import useCurrentBrand from './useCurrentBrand'

/** Interface for the fans store state and actions */
interface FansStore {
    // State
    searchFansInputValue: string
    isLoadingFansData: boolean
    isLoadingFansMaestroSearch: boolean
    isLoadingMetrics: boolean
    isLoadingImportStatus: boolean
    fansMaestroSearchResults: Fan[]
    fansData: Fan[]
    fansCount: number
    selectedFan: Fan | null
    showFansDetailsModal: boolean
    isFirstLoad: boolean

    // Actions
    setSearchFansInputValue: (value: string) => void
    setIsLoadingFansData: (value: boolean) => void
    setIsLoadingFansMaestroSearch: (value: boolean) => void
    setIsLoadingMetrics: (value: boolean) => void
    setIsLoadingImportStatus: (value: boolean) => void
    setFansMaestroSearchResults: (value: Fan[]) => void
    setFansData: (value: Fan[]) => void
    setFansCount: (value: number) => void
    setSelectedFan: (value: Fan | null) => void
    setShowFansDetailsModal: (value: boolean) => void
    setIsFirstLoad: (value: boolean) => void

    // Methods
    getFansData: (params?: FetchFanbaseParams) => Promise<void>
    sendFanSearchToMaestro: () => void
    emailMaestroFans: () => void
    saveMaestroAudience: () => void
}

const useFans = create<FansStore>()(
    immer((set, get) => ({
        // State
        searchFansInputValue: '',
        isLoadingFansData: false,
        isLoadingFansMaestroSearch: false,
        fansMaestroSearchResults: [],
        fansData: [],
        fansCount: 0,
        selectedFan: null,
        showFansDetailsModal: false,
        isFirstLoad: true,
        isLoadingMetrics: false,
        isLoadingImportStatus: false,

        // Actions
        setSearchFansInputValue: (value) => set((state) => { state.searchFansInputValue = value }),
        setIsLoadingFansData: (value) => set((state) => { state.isLoadingFansData = value }),
        setIsLoadingFansMaestroSearch: (value) => set((state) => { state.isLoadingFansMaestroSearch = value }),
        setFansMaestroSearchResults: (value) => set((state) => { state.fansMaestroSearchResults = value }),
        setFansData: (value) => set((state) => { state.fansData = value }),
        setFansCount: (value) => set((state) => { state.fansCount = value }),
        setSelectedFan: (value) => set((state) => { state.selectedFan = value }),
        setShowFansDetailsModal: (value) => set((state) => { state.showFansDetailsModal = value }),
        setIsFirstLoad: (value) => set((state) => { state.isFirstLoad = value }),
        setIsLoadingMetrics: (value) => set((state) => { state.isLoadingMetrics = value }),
        setIsLoadingImportStatus: (value) => set((state) => { state.isLoadingImportStatus = value }),

        // Methods
        getFansData: async (params?: FetchFanbaseParams) => {
            const { isLoadingFansData } = get()
            const { currentBrand } = useCurrentBrand.getState()
            const { id: brandId = 0 } = currentBrand || {}

            if(isLoadingFansData) {
                return
            }

            try {
                set((state) => { state.isLoadingFansData = true });
                const res = await getFanbase_api(brandId, params)
                if (res) {
                    const { fanbase, count } = res;
                    set((state) => {
                        state.fansData = fanbase
                        state.fansCount = count
                    });
                }
            } catch (error) {
                console.error('Error getting fans data:', error);
            } finally {
                set((state) => { 
                    state.isLoadingFansData = false
                    state.isFirstLoad = false
                });
            }
        },
        sendFanSearchToMaestro: () => {
            console.log('sendFanSearchToMaestro')
        },
        emailMaestroFans: () => {
            console.log('emailMaestroFans')
        },
        saveMaestroAudience: () => {
            console.log('saveMaestroAudience')
        }
    }))
)

export default useFans
